import styled from 'styled-components';

export const FooterListDownloadDataStyled = styled.div`
  display: flex;
  justify-content: space-between;
  width: 300px;
  @media (max-width: 650px) {
    width: 100%;
  }
  > div {
    margin-left: auto;
    > button {
      display: flex;
      align-items: center;
      justify-content: center;
      @media (max-width: 650px) {
        margin-top: 24px;
        width: 100%;
      }
      > img {
        margin-right: 8px;
        width: 16px;
        height: 16px;
      }
    }
    @media (max-width: 650px) {
      width: 100%;
    }
  }
`;
